import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiX } = FiIcons;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/servizi', label: 'Servizi' },
    { path: '/chi-siamo', label: 'Chi Siamo' },
    { path: '/simulatore', label: 'Simulatore' },
    { path: '/contatti', label: 'Contatti' }
  ];

  return (
    <motion.nav 
      initial={{ y: -100 }} 
      animate={{ y: 0 }} 
      className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg border-b border-brand-silver/30' : 'bg-transparent'}`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-3">
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://i.imghippo.com/files/DqZX5957Q.png" 
              alt="Castello SRL Logo" 
              className="h-14 w-auto object-contain transition-transform group-hover:scale-105"
            />
            <div className="flex flex-col">
              <span className={`text-xl font-bold leading-none ${scrolled ? 'text-brand-blue' : 'text-brand-blue'}`}>
                Castello <span className="text-brand-gold">SRL</span>
              </span>
              <span className="text-[10px] uppercase tracking-widest text-brand-subtle font-semibold">Property Management</span>
            </div>
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path} 
                className={`font-semibold text-sm uppercase tracking-wider transition-colors duration-200 ${location.pathname === item.path ? 'text-brand-gold' : 'text-brand-blue hover:text-brand-gold'}`}
              >
                {item.label}
              </Link>
            ))}
            <Link to="/simulatore" className="bg-brand-gold text-white px-5 py-2 rounded-lg text-sm font-bold hover:bg-brand-blue transition-all shadow-md">
              SIMULATORE
            </Link>
          </div>

          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="p-2 text-brand-blue">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="h-6 w-6" />
            </button>
          </div>
        </div>

        {isOpen && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} className="md:hidden bg-white shadow-xl rounded-2xl p-4 mt-2 border border-brand-silver">
            {navItems.map((item) => (
              <Link 
                key={item.path} 
                to={item.path} 
                onClick={() => setIsOpen(false)} 
                className="block px-4 py-3 text-brand-blue font-bold hover:bg-brand-silver/20 rounded-lg"
              >
                {item.label}
              </Link>
            ))}
          </motion.div>
        )}
      </div>
    </motion.nav>
  );
};

export default Navbar;